<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 30L13 19H35L24 30Z" clip-rule="evenodd" />
</svg>
